<div class="bv-main-container">
  <div class="bv-container">
    <section class="bv-container__loading" *ngIf="!isSuccess">
      <img
        class="bv-container__gif"
        [src]="assetsUrl + '/common/biometrics-scanner/loading.gif'"
        alt="loading"
      />
      <div class="bv-container__title">Estamos validando tu identidad</div>
      <div class="bv-container__text">Espera un momento</div>
    </section>
    <section class="bv-container__success" *ngIf="isSuccess">
      <div class="bv-container__image">
        <div class="bv-container__oval"></div>
        <img
          class="bv-container__svg"
          [src]="assetsUrl + 'common/biometrics-scanner/Exito.svg'"
          alt="success"
        />
      </div>
      <div class="bv-container__title">Tu identidad se ha verificado</div>
      <div class="bv-container__text">Podemos continuar</div>
    </section>
  </div>
</div>
